import removeIeFormElement from '../util/removeIeFormElement';
import CalculatorContainer from '../svelte/calculators/CalculatorContainer.svelte';

export default {
  init() {
    // remove IE mortgage calculators
    removeIeFormElement('#calculators-ie');

    // for accessing localized variables from PHP
    const sanctum = window.sanctum;

    // instantiate Svelte component - CalculatorContainer contains all the other calculator components
    new CalculatorContainer({
      target: document.querySelector('#calculators'),
      props: {
        // calculators display company name in disclaimer
        company: sanctum.company,
        // calculator select icons can be gray or color
        // WP stores this as 0 or 1 so translate into a boolean for Svelte
        grayIcons: sanctum.gray_icons === '1' ? false : true,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/calculators.js